import Model from "@/models/Model";
import Resource from "@/models/Resource";

export default class Author extends Model {
    resource() {
        return "authors";
    }

    baseURL() {
        return super.baseURL() + "/resourcecenter";
    }

    resources() {
        return this.hasMany(Resource);
    }
}
